import React from 'react';
import withStyles from '@mui/styles/withStyles';
import cx from 'classnames';

const styles = ({ palette, funeralHome }) => ({
    table: {
        borderSpacing: 0,
        borderCollapse: 'separate',
        fontSize: '0.875rem',
        width: '100%',
        '& th, & td': {
            borderStyle: 'solid',
            borderWidth: '1px 0px 0px 1px'
        },
        '& th:last-child, & td:last-child': {
            borderWidth: '1px 1px 0px 1px'
        },
        '& tr:last-child th, & tr:last-child td': {
            borderWidth: '1px 0px 1px 1px'
        },
        '& tr:last-child th:last-child, & tr:last-child td:last-child': {
            borderRightWidth: '1px'
        },
        '& tbody': {
            '& tr:last-of-type > td': { borderBottom: '2px solid ' + palette.baseSecondary[funeralHome] },
            '& tr:last-of-type > td:first-child': { borderBottomLeftRadius: 6 },
            '& tr:last-of-type > td:last-child': { borderBottomRightRadius: 6 }
        },
        '& tr:last-child': {
            '& > th, & > td': {
                '&[colspan]:first-child + *': {
                    borderBottomLeftRadius: 5
                }
            }
        },
        '&.table:not(.no-responsive) .row .td:before': {
            backgroundColor: palette.baseSecondary[funeralHome],
            color: 'white'
        }
    },
    tableHeaderRow: {
        '&.row--header th': {
            backgroundColor: palette.baseSecondary[funeralHome],
            border: '1px solid ' + palette.baseSecondary[funeralHome],
            borderLeft: '1px dotted #ffffff11',
            padding: '3px 0.5rem',
            height: '2.75rem',
            // color: palette.table.header.foregroundColor,
            // fontSize: '0.75rem',
            // fontWeight: '400',
            textAlign: 'left'
        },
        '&.row--header td': {
            backgroundColor: 'white',
            color: 'black'
            // fontSize: '0.875rem',
            // fontWeight: '400'
        },
        '& th:first-child': {
            borderTopLeftRadius: '6px'
        },
        '& th:last-child': {
            borderTopRightRadius: '6px'
        },
        '& td': {
            borderStyle: 'solid',
            borderWidth: '1px 0px 0px 1px',
            fontSize: '0.875rem;',
            padding: '0px 0.5rem',
            borderColor: palette.basePrimary[funeralHome] + 33
        }
    },

    tableSecondaryHeaderRow: {
        fontVariant: 'all-small-caps',
        '& th': {
            background: palette.table.headerSecondary.backgroundColor,
            borderColor: palette.basePrimary[funeralHome] + 33,
            padding: '0.625rem 0.5rem',
            color: palette.table.headerSecondary.foregroundColor,
            fontSize: '0.875rem',
            fontWeight: '500',
            textAlign: 'left',
            borderLeftStyle: 'dotted',
            borderTopColor: palette.baseSecondary[funeralHome]
        },
        '& th:first-child': {
            borderTopLeftRadius: '0px',
            borderLeftStyle: 'solid'
        },
        '& th:last-child': {
            borderTopRightRadius: '0px'
        }
    },

    tableRow: {
        '&:nth-child(2n+1)': { background: palette.baseSecondary[funeralHome] + '19' },
        '&:nth-child(2n)': { background: palette.baseSecondary[funeralHome] + '10' },
        '& td': {
            height: '2.25rem', // min height
            borderStyle: 'dotted',
            borderTopStyle: 'solid',
            borderBottomStyle: 'solid',
            borderWidth: '1px 0px 0px 1px',
            fontSize: '0.875rem;',
            padding: '0px 0.5rem',
            backgroundImage: 'radial-gradient(#ffffff99, transparent)',
            borderColor: palette.basePrimary[funeralHome] + 33,
            borderTopColor: palette.basePrimary[funeralHome] + 66,
            '&:first-child': {
                borderLeftStyle: 'solid'
            },
            '&:last-child': {
                borderRightStyle: 'solid'
            }
        },
        '&:nth-child(n):hover': {
            backgroundColor: palette.table.row.hoverColor
            // cursor: 'pointer'
        }
    },

    clickRow: {
        '&:hover': {
            cursor: 'pointer'
        }
    },

    tableNestedRow: {
        '& td': {
            borderStyle: 'solid',
            borderWidth: '1px 0px 0px 1px',
            borderColor: palette.basePrimary[funeralHome] + 33,
            background: palette.table.nestedRow.backgroundColor
        },
        '&:not(:last-child) td:last-child:first-child': {
            borderWidth: '1px 1px 0px 1px'
        },
        '& td:last-child': {
            borderWidth: '1px 1px 0px 0px'
        },
        '& tr:last-child td': {
            borderWidth: '1px 0px 1px 1px'
        },
        '& tr:last-child td:last-child': {
            //     borderWidth: '0px 1px 1px 0px '
        },
        '& td:first-child': {
            padding: '0.5rem 0.5rem 0.5rem 1.5rem'
        },
        '&:hover td': {
            backgroundColor: palette.table.nestedRow.hoverColor
        }
    },

    paddedRow: {
        '& td': {
            padding: '0.25rem'
        }
    },

    colXs: {
        width: '60px'
    },

    colSm: {
        width: '80px'
    },

    colMd: {
        width: '130px'
    },
    containerClassName: {
        overflow: 'auto',
        padding: 6,
        margin: -6,
        paddingLeft: 12,
        marginLeft: -12 // leave room for decorators
    }
});
const Table = withStyles(styles)(({ children, caption, thead, tbody, tfoot, columns, columnspans, ...props }) => {
    const { classes, containerClassName, className } = props;

    return (
        <div className={cx('table-container', classes.containerClassName, containerClassName)}>
            <table className={cx('table', classes.table, className)}>
                {caption && <caption>{caption}</caption>}
                {thead ||
                    (columns && (
                        <>
                            <colgroup>
                                {columns.map((column, columnIndex) => (
                                    <col key={columnIndex} span={(!!columnspans && columnspans[columnIndex]) || null} />
                                ))}
                            </colgroup>
                            <thead>
                                <TableHeaderRow>
                                    {columns.map((column, columnIndex) => (
                                        <TableHeaderCell
                                            dataLabel={column.label}
                                            colSpan={(!!columnspans && columnspans[columnIndex]) || null}
                                            key={column.label || columnIndex}
                                            tiny={column.tiny}
                                            className={column.headerClassName}
                                            style={column.headerStyle}
                                        >
                                            {column}
                                        </TableHeaderCell>
                                    ))}
                                </TableHeaderRow>
                            </thead>
                        </>
                    ))}
                {tbody || <tbody>{children}</tbody>}
                {tfoot}
            </table>
        </div>
    );
});

const TableHeaderRow = withStyles(styles)(({ pad, children, classes, className }) => {
    return (
        <tr className={cx(classes.tableHeaderRow, pad && classes.paddedRow, className, 'row--header')}>{children}</tr>
    );
});

const TableSecondaryHeaderRow = withStyles(styles)(({ pad, children, classes, className }) => {
    return <tr className={cx(classes.tableSecondaryHeaderRow, pad && classes.paddedRow, className)}>{children}</tr>;
});

const TableRow = withStyles(styles)(
    ({ pad, children, classes, className, onClick, onDragOver = null, onDragLeave = null, onDrop = null }) => {
        return (
            <tr
                className={cx(
                    classes.tableRow,
                    pad && classes.paddedRow,
                    onClick && classes.clickRow,
                    className,
                    'row'
                )}
                onClick={onClick}
                onDragOver={onDragOver}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
            >
                {children}
            </tr>
        );
    }
);
const DraggableTableRowBase = props => {
    const { pad, children, classes, className, onClick, draggableProps, muiRef, style } = props;
    return (
        <tr
            className={cx(classes.tableRow, pad && classes.paddedRow, onClick && classes.clickRow, className, 'row')}
            onClick={onClick}
            ref={muiRef}
            style={style}
            {...draggableProps}
        >
            {children}
        </tr>
    );
};
const StyledDraggableTableRow = withStyles(styles)(DraggableTableRowBase);
export const DraggableTableRow = React.forwardRef((props, ref) => <StyledDraggableTableRow {...props} muiRef={ref} />);

const TableNestedRow = withStyles(styles)(({ pad, children, classes, onClick }) => {
    return (
        <tr className={pad ? cx(classes.tableNestedRow, classes.paddedRow) : classes.tableNestedRow} onClick={onClick}>
            {children}
        </tr>
    );
});

const TableCell = withStyles(styles)(props => {
    const {
        className,
        pad,
        tiny = false,
        children,
        colSpan,
        rowSpan,
        dataLabel,
        style: styled,
        centred = false
    } = props;
    const style = { ...styled };
    if (pad) style.padding = '8px';
    if (false === pad) style.padding = '0';
    if (tiny) {
        style.width = '1px';
        style.height = 0;
    }
    if (centred) style.textAlign = 'center';
    return (
        <td className={cx(className, 'td')} style={style} colSpan={colSpan} rowSpan={rowSpan} data-label={dataLabel}>
            {children}
        </td>
    );
});

const TableHeaderCell = withStyles(styles)(props => {
    const { className, pad, tiny = false, children, colSpan, rowSpan, style: styled, centred } = props;
    const style = { ...styled };
    if (pad) style.padding = '8px';
    if (false === pad) style.padding = '0';
    if (tiny) {
        style.width = '1px';
        style.height = 0;
    }
    if (centred) style.textAlign = 'center';
    return (
        <th className={className} style={style} colSpan={colSpan} rowSpan={rowSpan}>
            {children}
        </th>
    );
});

export default Table;
export { TableHeaderRow, TableSecondaryHeaderRow, TableRow, TableNestedRow, TableCell, TableHeaderCell };
